/*
===============================================================================
  Bind v-lazy to image elements to lazyload images when scrolled into view
===============================================================================
*/

import Vue from 'vue';
import { DOCUMENT } from '../helpers/browser';

export default {
  inserted() {
    Vue.nextTick(() => {
      if (DOCUMENT.lazyLoadInstance) {
        DOCUMENT.lazyLoadInstance.update();
      }
    });
  },
};
